import { useRef } from 'react'

export const useLatest = <T>(value: T): { readonly current: T } => {
  const currentRef = useRef<T>(value)
  currentRef.current = value
  return currentRef
}
